module.exports = "/_next/static/images/aw-ab68008c5f85c16bf2d397586df566bb.svg";